import React from "react";
import {Card} from "react-bootstrap";
import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css'; 

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

function MapWidget(props) {
    const [map, setMap] = React.useState(null);
    const mapContainer = React.useRef(null);
    const [position, setPosition] = React.useState({
        "lat": props.position.lat,
        "lon": props.position.lon
    })

    
    // setPosition({
    //     lat: props.position.lat,
    //     lon: props.position.lon
    // })

    React.useEffect(async() => {
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        var latitude = props.position.lat;
        var longitude = props.position.lon;

        if(latitude >= 90 || latitude <= -90){
            latitude = 0;
        }
        if(longitude >= 90 || longitude <= -90){
            longitude = 0;
        }
        
        if(position.lat === 0){
            await setPosition({
                "lat": props.position.lat,
                "lon": props.position.lon
            })
        }


        else{
            const initializeMap = ({ setMap, mapContainer }) => {
                const map = new mapboxgl.Map({
                    container: mapContainer.current,
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: [longitude, latitude],
                    zoom: 4.5,
                    attributionControl: false
                });
                var marker = new mapboxgl.Marker({scale: 1.5})
                    .setLngLat([longitude, latitude])
                    .addTo(map)
            
                map.on("load", () => {
                    setMap(map);
                    map.resize();
                });

            }

            if (!map) initializeMap({ setMap, mapContainer });
            
        }
        
        
    }, [map, position]);
    
    return (
        <Card className="mb-8 ml-5 mt-5">
            <Card.Body style={{paddingLeft:"20px", paddingRight:"20px", paddingTop:"10px", paddingBottom:"10px", height:'275px'}}>
                <div ref={mapContainer} style={{height:'255px'}}></div>
            </Card.Body>
        </Card>
    );
  }
  
  export default MapWidget;